export default {
    status: {
        active: 'Active',
        disabled: 'Disabled',
        deleted: 'Deleted',
        verified: 'Verified',
        unverified: 'Unverified',
    },
    shared: {
        company: 'Company',
        locale: 'Locale',
        joined: 'Joined',
        lastLogin: 'Last login',
    },
    list: {
        title: 'Customers',
        search: 'Search by email, name, company or VAT number…',
        includeDeleted: 'Include deleted',
        empty: 'No customers yet.',
    },
    edit: {
        restore: 'Restore',
        profile: 'Profile',
        firstName: 'First name',
        lastName: 'Last name',
        vatNumber: 'VAT number',
        marketingOptIn: 'Marketing opt-in',
        disabled: 'Disabled',
        groups: 'Groups',
        groupsHelp: 'Groups decide which restricted pages, articles and products this customer can see. Saved with the rest of the profile.',
        noGroups: 'No groups on this website yet.',
        addresses: 'Addresses',
        noAddresses: 'No addresses on file. The customer adds these from their account.',
        addressShipping: 'shipping',
        addressBilling: 'billing',
        addressVat: 'VAT: {number}',
        account: 'Account',
        termsAccepted: 'Terms accepted',
        adminActions: 'Admin actions',
        adminActionsHelp: 'We never see or set passwords directly. The customer completes the flow via email.',
        resendVerification: 'Resend verification',
        sendPasswordReset: 'Send password reset',
        verificationSent: 'Verification email sent',
        confirmPasswordReset: 'Send a password reset email to {email}?',
        passwordResetSent: 'Password reset email sent',
        confirmDelete: 'Delete {email}? They will no longer be able to log in. You can restore them later.',
        deleted: 'Customer deleted',
        restored: 'Customer restored',
    },
    groups: {
        title: 'Customer groups',
        groups: 'Groups',
        help: 'Groups decide who can see restricted pages, articles, products and menu entries. Put customers in a group from their own page; pick the group on the content you want to restrict.',
        empty: 'No groups yet.',
        members: '{n} members | {n} member | {n} members',
        slugHint: 'Themes test this handle',
        slugHintNew: 'Optional, derived from the name',
        newGroup: 'New group',
        create: 'Create group',
        created: 'Group created',
        saved: 'Group saved',
        deleted: 'Group deleted',
        loadFailed: 'Could not load customer groups.',
        createFailed: 'Could not create the group.',
        saveFailed: 'Could not save the group.',
        deleteFailed: 'Could not delete the group.',
        confirmDelete: 'Delete "{name}"?\n\nAny page, article, product or menu entry restricted to this group will be left visible to nobody until you change its access.',
    },
    access: {
        public: 'Everyone',
        authenticated: 'Logged-in customers',
        groups: 'Selected customer groups',
    },
    settings: {
        sender: 'Customer mail sender',
        senderHelp: "Optional override for verification + password-reset emails. Leave blank to use the website's default sender.",
        fromEmail: 'From email',
        fromName: 'From name',
        defaultEmailMissing: 'Set the website default first',
        defaultNameFallback: 'Falls back to website default',
        save: 'Save customer settings',
    },
};
